import React, { useEffect, useState } from "react";
import UIBody from "../../../components/ui/UIBody";
import RoboticKit from "./RoboticKit";
import useApiCallHooks from "../../../hooks/useApiCallHooks";
import OverlayLoader from "../../../components/Common/OverlayLoader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const RoboticLabSetup = () => {
const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();

  
  const [formData, setFormData] = useState({
  first_name: '',
  last_name: '',
  email: '',
  mobile_no: '',
  description: '',
  type: 'Robotic kits'
});



  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submit
  const handleSubmit= (e) => {
    e.preventDefault();
    callAPI('post', 'add-contact-us', formData);
  };

  // Handle response
  useEffect(() => {
    if (responce?.data && statusCode === 200) {
      toast.success('Your message has been sent successfully!');
   
    }

    if (responce?.data && statusCode === 201) {
      toast.success('Contact created successfully!');
      setTimeout(() => {
        navigate('/');
      }, 1500);
    }

  }, [responce, statusCode, error, navigate]);

  return (
    <UIBody
    loading={loading}
      content={
        <>
          {/* Hero Section */}
          <section className="robotic-hero-section">
             <OverlayLoader show={loading} />
            <div className="container">
              <div className="row align-items-center">
                {/* Left Side - Text */}
                <div className="col-md-6 text-md-start text-center text-white mt-5 mb-4">
                  <h2 className="fw-bold display-5 mb-4 text-white">
                    Empower the Future with AI & Robotics Education
                    <br />
                    {/* <span >Artificial Intelligence</span> <br />
                                        To Business */}
                  </h2>
                  <p className="lead mb-4">
                    We help educational institutions, innovation hubs, and tech
                    centers build fully functional, AI-ready robotic labs that
                    inspire creativity and real-world problem-solving.
                  </p>
                  <div className="d-flex flex-wrap justify-content-md-start justify-content-center gap-3">
                   
                  </div>
                </div>

                {/* Right Side - Image */}
                <div className="col-md-6 text-center mt-4 mt-md-0 position-relative">
                  <img
                    src="/images/ui/robotic-lab/banner-image.png" // replace with your actual image path
                    alt="AI Robot"
                    className="img-fluid"
                    style={{ maxHeight: "510px" }}
                  />

                  <div className="robotic_shape">
                    <img
                      src="/images/ui/robotic-lab/graident-ai-robot-vectorart.png" // replace with your actual image path
                      alt="AI Robot"
                      className="h-20v animate-slide-left-right"
                      data-aos="fade-up-right"
                      data-aos-delay="800"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <RoboticKit />
          <section
            class="about-area-six about__bg"
            data-background="assets/img/bg/h8_about_bg.jpg"
          >
            <div class="container">
              <div class="row align-items-center justify-content-center">
                <div class="col-lg-6 col-md-10">
                  <div class="about__images-six">
                    <img src="/images/ui/robotic-lab/gang.jpg" alt="img" />
                    <img
                      src="/images/ui/robotic-lab/international-day-education-futuristic-style.jpg"
                      alt="img"
                      data-aos="fade-left"
                      data-aos-delay="400"
                      className="h-50"
                    />
                    <div
                      class="about__success"
                      data-aos="fade-up"
                      data-aos-delay="400"
                    >
                      <div class="icon">
                        <i class="skillgro-diploma-1"></i>
                      </div>
                      {/* <div class="content">
                                                <h2 class="title">86%</h2>
                                                <span>Course Success</span>
                                            </div> */}
                    </div>
                    <div class="shape">
                      <img
                        src="assets/img/others/h8_about_img_shape.svg"
                        alt="shape"
                        class="alltuchtopdown"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="about__content-six">
                    <div class="section__title mb-15">
                      <span class="sub-title">Get More About Us</span>
                      <h2 class="title">
                        Cutting-Edge
                        <span class="position-relative">
                          <svg
                            x="0px"
                            y="0px"
                            preserveAspectRatio="none"
                            viewBox="0 0 209 59"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.74438 7.70565C69.7006 -1.18799 136.097 -2.38304 203.934 4.1205C207.178 4.48495 209.422 7.14626 208.933 10.0534C206.793 23.6481 205.415 36.5704 204.801 48.8204C204.756 51.3291 202.246 53.5582 199.213 53.7955C136.093 59.7623 74.1922 60.5985 13.5091 56.3043C10.5653 56.0924 7.84371 53.7277 7.42158 51.0325C5.20725 38.2627 2.76333 25.6511 0.0898448 13.1978C-0.465589 10.5873 1.61173 8.1379 4.73327 7.70565"
                              fill="currentcolor"
                            />
                          </svg>
                          Robotic
                        </span>
                        Lab Setup
                      </h2>
                    </div>
                    <p>
                      State-of-the-art robotics kits and tools designed for
                      hands-on learning and innovation in schools and colleges.
                      Empower students to build, program, and experiment with
                      real robots.
                    </p>
                    <div className="d-flex gap-3 my-3">
                      <div>
                        <img
                          src="/images/ui/robotic-lab/Mieux-comprendre-satisfaction-client-F.jpg"
                          className="robotic-icone"
                          data-aos="fade-up-left"
                          data-aos-delay="400"
                        />
                      </div>
                      <div className="card-body">
                        <h4 className="mb-1">100% Practical Learning</h4>
                        <p className="m-0">
                          Our labs focus on experiential learning with real-time
                          projects, ensuring students get deep understanding and
                          hands-on skills in robotics and automation.
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-3 my-3">
                      <div>
                        <img
                          src="/images/ui/robotic-lab/standard-quality-control-concept-m.jpg"
                          className="robotic-icone"
                          data-aos="fade-up-left"
                          data-aos-delay="400"
                        />
                      </div>
                      <div className="card-body">
                        <h4 className="mb-1">Certified Quality Equipment</h4>
                        <p className="m-0">
                          We provide reliable, durable, and industry-grade
                          robotic kits and components, backed by quality
                          assurance and technical support for smooth lab
                          operation.
                        </p>
                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
            </div>
            <div class="about__shape-wrap">
              <img
                src="/images/ui/robotic-lab/robot-protecting-world.jpg"
                alt="shape"
                data-aos="fade-down-right"
                data-aos-delay="400"
              />
              <img
                src="/images/ui/robotic-lab/robot-with-documents-folder.jpg"
                alt="shape"
                data-aos="fade-up-left"
                data-aos-delay="400"
              />
            </div>
          </section>
          <section>
            <div className="container">
              <div className="row">
                <div class="col-lg-6 position-relative">
                  <div class="about__content-six">
                    <div class="section__title mb-15">
                      <span class="sub-title">Get More About Us</span>
                      <h1 class="title">
                        Our Purpose is To Deliver Our Purpose is to Deliver
                        <span class="position-relative">
                          <svg
                            x="0px"
                            y="0px"
                            preserveAspectRatio="none"
                            viewBox="0 0 209 59"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.74438 7.70565C69.7006 -1.18799 136.097 -2.38304 203.934 4.1205C207.178 4.48495 209.422 7.14626 208.933 10.0534C206.793 23.6481 205.415 36.5704 204.801 48.8204C204.756 51.3291 202.246 53.5582 199.213 53.7955C136.093 59.7623 74.1922 60.5985 13.5091 56.3043C10.5653 56.0924 7.84371 53.7277 7.42158 51.0325C5.20725 38.2627 2.76333 25.6511 0.0898448 13.1978C-0.465589 10.5873 1.61173 8.1379 4.73327 7.70565"
                              fill="currentcolor"
                            />
                          </svg>
                          Excellence
                        </span>{" "}
                        in Robotic Lab Setup and Support
                      </h1>
                    </div>
                    <p>
                      We ensure seamless installation, quality equipment, and
                      expert guidance so that educational institutions can
                      provide cutting-edge robotics learning experiences. Our
                      commitment is to empower students with hands-on technology
                      skills for the future.
                    </p>

                   
                  </div>
                  <div className="robotic_shape2">
                    <img
                      src="/images/ui/robotic-lab/two-boys-building-robot-white-background_1308-75699.png" // replace with your actual image path
                      alt="AI Robot"
                      className="h-20v"
                      data-aos="fade-up-right"
                      data-aos-delay="800"
                    />
                  </div>
                </div>
                <div className="col-lg-6 ">
                  <div className="row">
                    <div className="col-lg-6 ">
                      <div className="courses__item shine__animate-item me-1">
                        <div className="courses__item-thumb">
                          <img
                            src="/images/ui/robotic-lab/robotic-animation.jpg"
                            alt="course"
                          />
                        </div>
                        <div className="courses__item-content">
                          <h5 className="title m-0">
                            Innovative Robotics Labs
                          </h5>
                          <p className="courses_mini_titile my-2">
                            Hands-on setups to spark creativity and tech skills
                            in students.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 mt-lg-5 ">
                      <div className="courses__item shine__animate-item me-1">
                        <div className="courses__item-thumb">
                          <img
                            src="/images/ui/robotic-lab/robotic-animation.jpg"
                            alt="course"
                          />
                        </div>
                        <div className="courses__item-content">
                          <h5 className="title m-0">Future-Ready Classrooms</h5>
                          <p className="courses_mini_titile my-2">
                            Equip schools with smart tools for robotics and
                            automation learning.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="robotic_why_chose_section">
            <div className="container">
              <div className="row align-items-center pt-5">
                {/* Left Image */}
                <div className="col-md-6 text-center">
                  <img
                    src="/images/ui/robotic-lab/choose-image.png"
                    alt="Why Choose Robotic Lab"
                    className="img-fluid"
                  />
                </div>

                {/* Right Points */}
                <div className="col-md-6">
                  <h2 className="text-white mb-4">Why Choose Robotic Lab?</h2>
                  <ul className="list-unstyled text-white fs-5">
                    <li className="mb-3">🤖 Hands-on robotics projects</li>
                    <li className="mb-3">💡 Creativity-focused learning</li>
                    <li className="mb-3">👨‍🏫 Experienced instructors</li>
                    <li className="mb-3">🔧 Real-world applications</li>
                    <li className="mb-3">
                      🧠 Develop critical thinking & teamwork
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section class="robotic_faq_section py-5">
            <div class="container">
              <small class="text-info fw-bold robotic_faq_subtitle">
                FAQ,S
              </small>
              <h2 class="fw-bold robotic_faq_heading">
                Frequently Asked Questions
              </h2>
              <div class="row align-items-start mt-3">
                <div class="col-md-6">
                  <div
                    class="accordion robotic_faq_accordion"
                    id="faqAccordion"
                  >
                    <div class="accordion-item border-0 mb-3 rounded-4 shadow-sm robotic_faq_card">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed robotic_faq_question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq1"
                        >
                          What is included in the robotic lab setup?
                        </button>
                      </h2>
                      <div
                        id="faq1"
                        class="accordion-collapse collapse"
                        data-bs-parent="#faqAccordion"
                      >
                        <div class="accordion-body">
                          Our setup includes robotics kits, sensors,
                          controllers, software tools, laptops/tablets
                          (optional), curriculum, and instructor manuals.
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item border-0 mb-3 rounded-4 shadow-sm robotic_faq_card">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed robotic_faq_question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq2"
                        >
                          What age group is the lab suitable for?
                        </button>
                      </h2>
                      <div
                        id="faq2"
                        class="accordion-collapse collapse"
                        data-bs-parent="#faqAccordion"
                      >
                        <div class="accordion-body">
                          We offer customized labs for students aged 8 and
                          above, suitable for both school and college levels.
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item border-0 mb-3 rounded-4 shadow-sm robotic_faq_card">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed robotic_faq_question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq3"
                        >
                          Do you provide training for teachers?
                        </button>
                      </h2>
                      <div
                        id="faq3"
                        class="accordion-collapse collapse"
                        data-bs-parent="#faqAccordion"
                      >
                        <div class="accordion-body">
                          Yes, we offer comprehensive teacher training programs
                          to ensure effective implementation and hands-on
                          guidance.
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item border-0 mb-3 rounded-4 shadow-sm robotic_faq_card">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed robotic_faq_question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq4"
                        >
                          Is internet required for the lab to function?
                        </button>
                      </h2>
                      <div
                        id="faq4"
                        class="accordion-collapse collapse"
                        data-bs-parent="#faqAccordion"
                      >
                        <div class="accordion-body">
                          Most features work offline, but certain AI or
                          cloud-based modules may require internet access.
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item border-0 mb-3 rounded-4 shadow-sm robotic_faq_card">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed robotic_faq_question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq5"
                        >
                          Can we integrate this with our school’s curriculum?
                        </button>
                      </h2>
                      <div
                        id="faq5"
                        class="accordion-collapse collapse"
                        data-bs-parent="#faqAccordion"
                      >
                        <div class="accordion-body">
                          Yes, our modules align with STEM/NEP guidelines and
                          can be smoothly integrated into existing subjects.
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item border-0 mb-3 rounded-4 shadow-sm robotic_faq_card">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed robotic_faq_question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq6"
                        >
                          Do you offer support after installation?
                        </button>
                      </h2>
                      <div
                        id="faq6"
                        class="accordion-collapse collapse"
                        data-bs-parent="#faqAccordion"
                      >
                        <div class="accordion-body">
                          Yes, we offer technical support, updates, and
                          curriculum enhancements after the lab is set up.
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item border-0 mb-3 rounded-4 shadow-sm robotic_faq_card">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed robotic_faq_question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq7"
                        >
                          What space and power setup is required?
                        </button>
                      </h2>
                      <div
                        id="faq7"
                        class="accordion-collapse collapse"
                        data-bs-parent="#faqAccordion"
                      >
                        <div class="accordion-body">
                          A basic classroom with tables, chairs, and power
                          sockets is enough. We also provide layout plans for
                          your convenience.
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item border-0 mb-3 rounded-4 shadow-sm robotic_faq_card">
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button collapsed robotic_faq_question"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq8"
                        >
                          Can the lab be upgraded in the future?
                        </button>
                      </h2>
                      <div
                        id="faq8"
                        class="accordion-collapse collapse"
                        data-bs-parent="#faqAccordion"
                      >
                        <div class="accordion-body">
                          Yes, our lab is modular and scalable. You can expand
                          it anytime with advanced kits, AI modules, and more.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

<div className="col-md-6 mt-4 mt-md-0">
  <div className="singUp-wrap shadow">
    <h2 className="title">Reach Out to Us</h2>
    <form className="account__form" onSubmit={handleSubmit}>
      <div className="row gutter-20">
        <div className="col-md-6">
          <div className="form-grp">
            <label htmlFor="first-name">First Name</label>
            <input
              type="text"
              id="first-name"
              name="first_name"
              placeholder="First Name"
              value={formData.first_name}
              onChange={handleChange}
            />
            <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.first_name}
                </span>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-grp">
            <label htmlFor="last-name">Last Name</label>
            <input
              type="text"
              id="last-name"
              name="last_name"
              placeholder="Last Name"
              value={formData.last_name}
              onChange={handleChange}
            />
             <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.last_name}
                </span>
          
          </div>
        </div>
      </div>

      <div className="form-grp">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
        />
        <span className="val-message text-danger">
          {error?.message === "ValidationError" && error?.data?.email}
        </span>
      </div>

      <div className="form-grp">
        <label htmlFor="mobile">Mobile No</label>
        <input
          type="number"
          id="mobile"
          name="mobile_no"
          placeholder="Mobile No"
          value={formData.mobile_no}
          onChange={handleChange}
        />
        <span className="val-message text-danger">
          {error?.message === "ValidationError" && error?.data?.mobile_no}
        </span>
      </div>

      <div className="form-grp">
        <label htmlFor="description">Description</label>
        <textarea
          id="description"
          name="description"
          rows="2"
          className="form-control"
          placeholder="Write your message here..."
          value={formData.description}
          onChange={handleChange}
        />
        <span className="val-message text-danger">
          {error?.message === "ValidationError" && error?.data?.description}
        </span>
      </div>

      {/* Hidden type field */}
        <div className="form-grp">
      <input type="hidden" name="type" value={formData.type} />
        
        </div>

      <button type="submit" className="btn text-white rounded">
        Submit Request
      </button>
    </form>
  </div>
</div>



              </div>
            </div>
          </section>
        </>
      }
    />
  );
};

export default RoboticLabSetup;
